import { motion } from "framer-motion";

const AI_BG = "/ai-bg.png";

const impactAreas = [
  "Turning data into predictive insight",
  "Embedding intelligence into core product workflows",
  "Faster, sharper executive decision-making",
  "Compounding efficiency through automation",
];

const outcomes = [
  "Faster execution and decision cycles",
  "Lower operating cost",
  "New revenue streams from intelligent features",
  "Sharper differentiation in crowded markets",
];

export const AIInnovation = () => {
  return (
    <section
      data-testid="ai-innovation-section"
      className="relative py-20 sm:py-28 md:py-44 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${AI_BG})` }}
      />
      <div className="absolute inset-0 bg-[#050505]/85" />
      <div className="grain absolute inset-0" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#C5A880]" />
              <span className="text-[11px] font-semibold tracking-[0.3em] uppercase text-[#C5A880]">
                AI-Led Innovation / 04
              </span>
            </div>
            <h2
              data-testid="ai-heading"
              className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] lg:leading-[1.05] tracking-tight text-[#F5F5F0]"
            >
              Turning AI from boardroom hype into{" "}
              <em className="italic text-[#C5A880]">product P&amp;L</em>.
            </h2>
            <p className="mt-6 sm:mt-8 max-w-xl text-[15px] sm:text-base md:text-lg text-[#A3A39A] leading-relaxed">
              AI as a competitive advantage — not a side project. The work is
              grounded in product strategy and measured in revenue, retention
              and decision velocity.
            </p>
          </div>
        </div>

        <div className="mt-12 sm:mt-16 md:mt-24 grid grid-cols-1 lg:grid-cols-2 gap-px bg-[#1a1a1a] border border-[#1a1a1a]">
          <div className="bg-[#080808] p-6 sm:p-8 md:p-12">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#C5A880] mb-6 sm:mb-8">
              Where I drive impact
            </div>
            <ul className="space-y-4 sm:space-y-5">
              {impactAreas.map((item, i) => (
                <motion.li
                  key={item}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.06 }}
                  className="flex items-start gap-4 font-serif-display text-lg sm:text-xl md:text-2xl font-light text-[#F5F5F0]"
                >
                  <span className="text-[#C5A880] text-sm tracking-widest mt-1 sm:mt-2 flex-shrink-0">
                    0{i + 1}
                  </span>
                  <span>{item}</span>
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="bg-[#080808] p-6 sm:p-8 md:p-12">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#C5A880] mb-6 sm:mb-8">
              Typical outcomes
            </div>
            <ul className="space-y-4 sm:space-y-5">
              {outcomes.map((item, i) => (
                <motion.li
                  key={item}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.06 }}
                  className="flex items-start gap-4 text-[15px] sm:text-base md:text-lg text-[#D8D8D0]"
                >
                  <span className="mt-2 inline-block h-px w-5 bg-[#C5A880] flex-shrink-0" />
                  <span>{item}</span>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIInnovation;
